import { useTranslation } from 'react-i18next'

import { useDateLimits } from '../../../../../hooks'
import { getQaSelector } from '../../../../../utils/common'
import { stopPropagation } from '../../../../../utils/events'
import { DatePicker } from '../../../../DateTime'
import { EntityProfileHeaderInfoItemBase } from '../../../../Entity'
import { Status } from '../../../../Status'
import Text from '../../../../Text'
import { QA_NAME_APPLICANT_PROFILE_INFO_FOLLOW_UP } from '../RentalPortalApplicantProfileHeaderInfoItems.constants'
import {
  getApplicantFollowUpTextColor,
  getApplicantShortDate,
} from '../RentalPortalApplicantProfileHeaderInfoItems.utils'

import {
  APPLICANT_PROFILE_FOLLOW_UP_ACTION_KEY_ADD,
  APPLICANT_PROFILE_FOLLOW_UP_ACTION_KEY_DELETE,
  APPLICANT_PROFILE_FOLLOW_UP_ACTION_KEY_EDIT,
  APPLICANT_PROFILE_FOLLOW_UP_ACTIONS,
  QA_NAME_APPLICANT_PROFILE_FOLLOW_UP_CELL,
  QA_NAME_APPLICANT_PROFILE_FOLLOW_UP_INPUT,
} from './ApplicantProfileFollowUpItem.constants'
import { useApplicantFollowUpEdit } from './ApplicantProfileFollowUpItem.hooks'

import * as styles from './ApplicantProfileFollowUpItem.module.css'

function ApplicantProfileFollowUpItem({
  canEdit,
  className,
  contentWrapperClassName,
  isTerminal,
  titleClassName,
  value,
  onSaveValue,
  ...restProps
}) {
  const { t } = useTranslation()

  const { maxDate, minDate } = useDateLimits()

  const {
    dateInputRef,
    editContainerRef,
    editValue,
    handleChangeEditValue,
    handleDeleteValue,
    handleStartEditing,
    hasError,
    isEditing,
    isSaving,
  } = useApplicantFollowUpEdit({ value, onSaveValue })

  function handleClickDelete(event) {
    stopPropagation(event)

    handleDeleteValue()
  }

  return isEditing ? (
    <div className={className}>
      <Text isSecondary className={titleClassName}>
        {t(restProps.title)}
      </Text>
      <div className={styles.editFieldsWrapper} ref={editContainerRef}>
        <DatePicker
          autoFocus
          disabled={isSaving}
          maxValue={maxDate}
          minValue={minDate}
          qaName={QA_NAME_APPLICANT_PROFILE_FOLLOW_UP_INPUT}
          ref={dateInputRef}
          showError={hasError}
          value={editValue}
          wrapperClassName={styles.datePickerWrap}
          onChange={handleChangeEditValue}
        />
      </div>
    </div>
  ) : (
    <EntityProfileHeaderInfoItemBase
      {...restProps}
      actions={canEdit ? APPLICANT_PROFILE_FOLLOW_UP_ACTIONS : null}
      canEdit={canEdit}
      className={className}
      contentExist={Boolean(value)}
      contentWrapperClassName={contentWrapperClassName}
      contentWrapperProps={
        canEdit
          ? {
              ...getQaSelector({
                value: QA_NAME_APPLICANT_PROFILE_FOLLOW_UP_CELL,
              }),
              onClick: handleStartEditing,
            }
          : null
      }
      handlers={{
        [APPLICANT_PROFILE_FOLLOW_UP_ACTION_KEY_ADD]: {
          onClick: handleStartEditing,
        },
        [APPLICANT_PROFILE_FOLLOW_UP_ACTION_KEY_DELETE]: {
          onClick: handleClickDelete,
        },
        [APPLICANT_PROFILE_FOLLOW_UP_ACTION_KEY_EDIT]: {
          onClick: handleStartEditing,
        },
      }}
      titleClassName={titleClassName}
      value={value}
    >
      {value ? (
        <Status
          qaName={QA_NAME_APPLICANT_PROFILE_INFO_FOLLOW_UP}
          text={getApplicantShortDate(value)}
          textColor={getApplicantFollowUpTextColor({ isTerminal, value })}
        />
      ) : (
        <Text
          disabled
          isSecondary
          qaName={QA_NAME_APPLICANT_PROFILE_INFO_FOLLOW_UP}
        >
          {t('Select.NoDataKey')}
        </Text>
      )}
    </EntityProfileHeaderInfoItemBase>
  )
}

export default ApplicantProfileFollowUpItem
